//====================================================
//UHS we use this file
//====================================================
$(document).ready(function() {
  
  $(document).on('click', '.custom-header__link-lvl-one', function(event) {
    
    event.preventDefault();
    const menu_name = $(this).find('li').text();

    if($(this).hasClass('custom-header__active-menu')) {
      $('.custom-header__active-menu').removeClass('custom-header__active-menu');
      $('[data-parent-link]').removeClass('custom-header__megamenu--active');
    } else {
      $('.custom-header__active-menu').removeClass('custom-header__active-menu');
      $('[data-parent-link]').removeClass('custom-header__megamenu--active');
      $(this).toggleClass('custom-header__active-menu');
      $('[data-parent-link="' + menu_name + '"]').toggleClass('custom-header__megamenu--active');
    }
    
  });


    $(document).on('mouseover', '.custom-header__link-lvl-one', function(event) {
    
    event.preventDefault();
    const menu_name = $(this).find('li').text();

    if($(this).hasClass('custom-header__active-menu')) {
      $('.custom-header__active-menu').removeClass('custom-header__active-menu');
      $('[data-parent-link]').removeClass('custom-header__megamenu--active');
    } else {
      $('.custom-header__active-menu').removeClass('custom-header__active-menu');
      $('[data-parent-link]').removeClass('custom-header__megamenu--active');
      $(this).toggleClass('custom-header__active-menu');
      $('[data-parent-link="' + menu_name + '"]').toggleClass('custom-header__megamenu--active');
    }
    
  });
 
$(document).on('mouseout', '.search-header__container, .actions-header__container, .info-header__container, #MainContent', function() {
  $('.custom-header__active-menu').removeClass('custom-header__active-menu');
    $('[data-parent-link]').removeClass('custom-header__megamenu--active');
 });




  
});

